export default __webpack_public_path__ + "static/char-49-c61e5f3b685fb0b18c97354c0510d31d.webp";